import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles(theme => ({
  root: {
    color: "#ffffff",
    backgroundColor: "#005F87",
    border: "solid 1px #003750",
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.3)",
    borderRadius: 2,
    height: 32,
    "&:hover": {
      backgroundColor: "#004D73",
      boxShadow: "0px 1px 6px 0px rgba(0, 0, 0, 0.3)"
    },
    "&:active": {
      backgroundColor: "#003750",
      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.3)"
    },
    "&:focus": {
      outline: "solid 2px #0F789B",
      backgroundColor: "#005F87",
      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.3)",
      outlineOffset: 2
    },
    "&.Mui-disabled": {
      backgroundColor: "#00000026",
      color: "#0000004D",
      border: "1px solid #0000004D"
    }
  }
}));

interface AccentButtonProps {
  text?: string;
  onClick?: () => void;
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
}

const AccentButton: React.FC<AccentButtonProps> = ({
  text,
  onClick,
  className,
  type,
  disabled
}) => {
  const classes = useStyles();
  return (
    <Button
      size="small"
      variant="contained"
      className={className ? `${classes.root} ${className}` : classes.root}
      disableRipple
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {text}
    </Button>
  );
};

export default AccentButton;
